import {
  CompanyDepartmentKeys,
  CompanyDepartments,
} from '@aibees/elephant/feature/search-table-company/types';

export const DEPARTMENTS_TRANSLATIONS: {
  [key in CompanyDepartmentKeys]: string;
} = {
  all: 'All Departments',
  [CompanyDepartments.accounting]: 'Accounting',
  [CompanyDepartments.program_and_project_management]: 'Project Management',
  [CompanyDepartments.education]: 'Education',
  [CompanyDepartments.purchasing]: 'Purchasing',
  [CompanyDepartments.sales]: 'Sales',
  [CompanyDepartments.research]: 'Research',
  [CompanyDepartments.operations]: 'Operations',
  [CompanyDepartments.customer_success_and_support]: 'Customer Support',
  [CompanyDepartments.legal]: 'Legal',
  [CompanyDepartments.product_management]: 'Product Management',
  [CompanyDepartments.media_and_communication]: 'Media & Communication',
  [CompanyDepartments.real_estate]: 'Real Estate',
  [CompanyDepartments.quality_assurance]: 'Quality Assurance',
  [CompanyDepartments.consulting]: 'Consulting',
  [CompanyDepartments.arts_and_design]: 'Design',
  [CompanyDepartments.healthcare_services]: 'Healthcare Services',
  [CompanyDepartments.entrepreneurship]: 'Entrepreneurship',
  [CompanyDepartments.engineering]: 'Engineering',
  [CompanyDepartments.community_and_social_services]:
    'Community & Social Services',
  [CompanyDepartments.marketing]: 'Marketing',
  [CompanyDepartments.information_technology]: 'Information Technology',
  [CompanyDepartments.business_development]: 'Business Development',
  [CompanyDepartments.administrative]: 'Administrative',
  [CompanyDepartments.military_and_protective_services]:
    'Military & Protective Services',
  [CompanyDepartments.finance]: 'Finance',
  [CompanyDepartments.human_resources]: 'Human Resources',
};
